"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal["default"];
  }
});
Object.defineProperty(exports, "IsModalOpenConsumer", {
  enumerable: true,
  get: function get() {
    return _isOpenContext.Consumer;
  }
});

var _Modal = _interopRequireDefault(require("./Modal"));

var _isOpenContext = require("./isOpenContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }